import { render, staticRenderFns } from "./ConstituencyList.vue?vue&type=template&id=ed03799c&"
import script from "./ConstituencyList.vue?vue&type=script&lang=js&"
export * from "./ConstituencyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports